import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { HomepageComponent }   from './components/homepage/homepage';
import { SignInUpComponent }  from './components/sign-in-up/sign-in-up';
import { LogoutComponent }  from './components/logout/logout';
import { SettingsComponent }  from './components/settings/settings';
import { AdminComponent }  from './components/admin/admin';
import { ManageListsRecipesComponent }  from './components/manage-lists-recipes/manage-lists-recipes';
import { ListRecipeComponent }  from './components/list-recipe/list-recipe';

const routes : Routes = [
  {
    path: '',
    component: HomepageComponent
  },
  {
    path: 'signin',
    component: SignInUpComponent
  },
  {
    path: 'signup',
    component: SignInUpComponent
  },
  {
    path: 'logout',
    component: LogoutComponent
  },
  {
    path: 'settings',
    component: SettingsComponent
  },
  {
    path: 'admin',
    component: AdminComponent
  },
  {
    path: 'lists',
    component: ManageListsRecipesComponent
  },
  {
    path: 'recipes',
    component: ManageListsRecipesComponent
  },
  {
    path: 'list/:key',
    component: ListRecipeComponent
  },
  {
    path: 'shared-list/:shared-key',
    component: ListRecipeComponent
  },
  {
    path: 'recipe/:recipe-key',
    component: ListRecipeComponent
  }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})

export class AppRoutingModule {}


// WEBPACK FOOTER //
// /Users/briznad/Documents/WebDev/personal/cartmigo/cartmigo-beta/src/app/app-routing.module.ts